import { render, staticRenderFns } from "./EditDelivery.vue?vue&type=template&id=0285819c"
import script from "./EditDelivery.vue?vue&type=script&lang=js"
export * from "./EditDelivery.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./EditDelivery.vue?vue&type=custom&index=0&blockType=docs"
if (typeof block0 === 'function') block0(component)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0285819c')) {
      api.createRecord('0285819c', component.options)
    } else {
      api.reload('0285819c', component.options)
    }
    module.hot.accept("./EditDelivery.vue?vue&type=template&id=0285819c", function () {
      api.rerender('0285819c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/shop/src/views/EditDelivery.vue"
export default component.exports